export default "__VITE_ASSET__cd34a579__"